import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

@Injectable()
export class InventoryService {

    private api_url_get_articles_inventaire = './api/server.php?cmd=GET_ARTICLES_INVENTAIRE';
    private api_url_set_articles_a_inventorier = './api/server.php?cmd=SET_ARTICLES_A_INVENTORIER';
    private api_url_update_quantity_in_inventaire = './api/server.php?cmd=UPDATE_QUANTITY_IN_INVENTAIRE';
    private api_url_remove_in_inventaire = './api/server.php?cmd=REMOVE_IN_INVENTAIRE';
    private api_url_save_inventaire = './api/server.php?cmd=SAVE_INVENTAIRE';
    //private api_url_reset_inventaire = './api/server.php?cmd=DESTROY_SESSION_INVENTAIRE';
    private api_url_reset_inventaire = './api/server.php?cmd=CANCEL_MODIFCATION_INVENTAIRE';
    //    rapport
    private api_url_get_rapports = './api/server.php?cmd=GET_RAPPORTS';
    private api_url_get_details_rapports = './api/server.php?cmd=GET_DETAILS_RAPPORTS';
    private api_url_get_new_reference = './api/server.php?cmd=GET_NEW_INVENTORY_REF';
    private api_url_new_inventory = './api/server.php?cmd=NEW_INVENTAIRE';
    private api_url_search_inventory = './api/server.php?cmd=SEARCH_INVENTAIRE';
    private api_url_load_stocktaking_infos = './api/server.php?cmd=LOAD_STOCKTAKING_INFOS';
    private api_url_load_stocktaking_article_to_analyse = './api/server.php?cmd=LOAD_STOCKTAKING_ART_ANALYSE'
    private api_url_registred_stocktaking = './api/server.php?cmd=REGISTRED_STOCKTAKING';
    private api_url_recount_art_stocktaking = './api/server.php?cmd=RECOUNT_ARTICLE_STOCKTAKING';
    private api_url_finished_stocktaking = './api/server.php?cmd=FINISHED_STOCKTAKING';
    private api_url_adjustement_art_stocktaking = './api/server.php?cmd=ADJUST_ARTICLE_STOCKTAKING';
    private api_url_get_stocktaking = './api/server.php?cmd=GET_LASTEST_STOCKTAKING';

    constructor(private http: Http) {}

    Insert(ref: any, name: any, start_time: any, responsible: any, team_member: any): Promise<Object> {
        return this.http.get(this.api_url_new_inventory
            + '&ref=' + ref
            + '&name=' + name
            + '&start_time=' + start_time
            + '&responsible=' + responsible
            + '&team_member=' + team_member
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    Recount(id_stocktaking: any, list: any, action :any): Promise<Object> {
        return this.http.get(this.api_url_recount_art_stocktaking
            + '&id_stocktaking=' + id_stocktaking
            + '&selected=' + list
            + '&action=' + action
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }
    
    /*Adjustement(id_stocktaking: any, list: any): Promise<Object> {
        return this.http.get(this.api_url_adjustement_art_stocktaking
            + '&id_stocktaking=' + id_stocktaking
            + '&selected=' + list
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }*/

    FinishedStocktaking(id_stocktaking: any): Promise<Object> {
        return this.http.get(this.api_url_finished_stocktaking
            + '&id_stocktaking=' + id_stocktaking
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }


    LoadStockTakingInfos(id_stocktaking: any): Promise<Object> {
        return this.http.get(this.api_url_load_stocktaking_infos
            + '&id_stocktaking=' + id_stocktaking

        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }


    LoadStockTakingArticleAnalyse(id_stocktaking: any): Promise<Object> {
        return this.http.get(this.api_url_load_stocktaking_article_to_analyse
            + '&id_stocktaking=' + id_stocktaking

        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getArticles(name: any, internal_code: any, supplier_code: any, category: any): Promise<Object> {
        return this.http.get(this.api_url_get_articles_inventaire
            + '&name=' + name
            + '&internal_code=' + internal_code
            + '&supplier_code=' + supplier_code
            + '&category=' + category
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    countArticle(id_article: any, name: any, category: any, internal_code: any, supplier_code: any, state: any): Promise<Object> {
        return this.http.get(this.api_url_set_articles_a_inventorier
            + '&id_article=' + id_article
            + '&name=' + name
            + '&category=' + category
            + '&internal_code=' + internal_code
            + '&supplier_code=' + supplier_code
            + '&state=' + state
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    remove(id_article: any): Promise<Object> {
        return this.http.get(this.api_url_remove_in_inventaire
            + '&id_article=' + id_article
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    editAndValidateModification(id_article: any, quantity: any): Promise<Object> {
        return this.http.get(this.api_url_update_quantity_in_inventaire
            + '&id_article=' + id_article
            + '&quantity=' + quantity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RegstredStocktaking(id_stocktaking: any, state: any, action :any): Promise<Object> {
        return this.http.get(this.api_url_registred_stocktaking
            + '&id_stocktaking=' + id_stocktaking
            + '&state=' + state
            + '&action=' + action
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }


    doInventory(): Promise<Object> {
        return this.http.get(this.api_url_save_inventaire)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    reset(): Promise<Object> {
        return this.http.get(this.api_url_reset_inventaire)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);

    }
    
    GetLastestStocktaking(): Promise<Object> {
        return this.http.get(this.api_url_get_stocktaking)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    //    rapport
    getRapports(reference: any, date: any): Promise<Object> {
        return this.http.get(this.api_url_get_rapports
            + '&reference=' + reference
            + '&date=' + date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    searchInventory(reference: any, date: any): Promise<Object> {
        return this.http.get(this.api_url_search_inventory
            + '&reference=' + reference
            + '&date=' + date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }


    viewDetails(id_rapport: any): Promise<Object> {
        return this.http.get(this.api_url_get_details_rapports
            + '&id_rapport=' + id_rapport
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);

    }

    GetInventoryReference(): Promise<Object> {
        return this.http.get(this.api_url_get_new_reference
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);

    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/inventory.service.ts